import { createSelector } from '@ngrx/store';
import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';
import {
  entityAcreditacionEmpresaAdapter,
  EntityAcreditacionEmpresaState
} from './entity-acreditacion-empresa.state';
import { selectAllEntityEtapasEmpresa } from '../entity-etapas-empresa/entity-etapas-empresa.selectors';
import { selectAllEntityEspeciesCertificables } from '../../actividades/entity-especies-certificables/entity-especies-certificables.selectors';
import { selectCurrentEmpresa } from '../entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } =
  entityAcreditacionEmpresaAdapter.getSelectors();

export const getError = (state: EntityAcreditacionEmpresaState): any =>
  state.error;

export const getIsLoading = (state: EntityAcreditacionEmpresaState): boolean =>
  state.isLoading;

export const selectEntityAcreditacionEmpresaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.acreditacionEmpresa
);

export const selectAllEntityAcreditacionEmpresa = createSelector(
  selectEntityAcreditacionEmpresaState,
  selectAll
);

export const selectAcreditacionEmpresaByCurrentEmpresa = createSelector(
  selectCurrentEmpresa,
  selectAllEntityAcreditacionEmpresa,
  (empresa, acreditaciones) => {
    if (!empresa || !empresa.id) {
      return [];
    }
    const resultado = acreditaciones.filter(
      (acreditacion) => acreditacion.entidad_productiva_id === empresa.id
    );
    return resultado || [];
  }
);

export const selectEntityAcreditacionEmpresaError = createSelector(
  selectEntityAcreditacionEmpresaState,
  getError
);

export const selectEntityAcreditacionEmpresaIsLoading = createSelector(
  selectEntityAcreditacionEmpresaState,
  getIsLoading
);

export const selectAcreditacionEmpresaById = (id: number) =>
  createSelector(selectAllEntityAcreditacionEmpresa, (allAcreditaciones) => {
    const acreditacion = allAcreditaciones.find(
      (acreditacion) => acreditacion.id === +id
    );

    return acreditacion;
  });

export const selectAcreditacionEmpresaByEntidadProductiva = (id: number) =>
  createSelector(selectAllEntityAcreditacionEmpresa, (allAcreditaciones) => {
    const acreditacion = allAcreditaciones.find(
      (acreditacion) => acreditacion.entidad_productiva_id === +id
    );
    return acreditacion;
  });

export const selectEntityAcreditacionEmpresaAddedSuccess = createSelector(
  selectEntityAcreditacionEmpresaState,
  (state) => state.hasAddedSuccess
);
